import React from "react";
import {Block, Icon, Title} from "../../../../components/components";
import ShowItem from "../../../../components/ShowItem";
import {useHistory, useParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {useDeleteUserMutation, useGetUserQuery} from "../../../../api/userApiSlice";
import useActionConfirmation from "../../../../components/useActionConfirmation";
import {Button} from "react-bootstrap";
import * as Format from "../../../../components/Format";

function User(props) {
  const { t } = useTranslation();
  const { userId } = useParams();
  const {data: user, isSuccess} = useGetUserQuery(userId)
  const [deleteUser] = useDeleteUserMutation()
  const history = useHistory();
  const rolePrefix = "data_vendor_"

  const {Confirmation, confirmationProps, confirm} = useActionConfirmation()

  const handleDelete = function() {
    deleteUser(userId).unwrap()
      .then(() => {
        history.push(`/users`);
      })
  }

  if (!isSuccess) { return (<></>) }
  return (
    <>
      <Title main={t("menu.users")} sub={`${user.firstName} ${user.lastName}`} backPath="/users">
        <Button onClick={() => history.push(`/users/${userId}/edit`)}>
          <Icon icon='edit' text={t("edit")} />
        </Button>
        <Button onClick={() => confirm(handleDelete, user.lastName)}>
          <Icon icon='trash' text={t("delete")} />
        </Button>
      </Title>
      <Block>
        <ShowItem label={t("users.firstName")} value={user.firstName} />
        <ShowItem label={t("users.lastName")} value={user.lastName} />
        <ShowItem label={t("users.email")} value={user.email} />
        <ShowItem label={t("users.phoneNumber")} value={user.phoneNumber} />
        <ShowItem label={t("users.createdAt")}>
          <Format.Date date={user.createdAt} />
        </ShowItem>
        <ShowItem label={t("users.roles")} array value={user.roles.map(role => t("user."+role.replace(rolePrefix, '')))}/>
      </Block>
      <Confirmation placeholder="Please enter user last name" {...confirmationProps} deletion />
    </>
  )
}

export default User
